/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseAudioBookReturn } from '../models/BaseAudioBookReturn';
import type { CompleteAudioBookReturn } from '../models/CompleteAudioBookReturn';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AudiobooksService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List all the books based on the given search params.
     * List retrieved from the project PodcastIndex API.
     *
     * These params are taken from the PodcastIndex API to match their available queries.
     * https://podcastindex-org.github.io/docs-api/#overview--postman
     * @param person Use this to search for an audiobook by author
     * @param term Use this to search author names and book titles with given words.
     * @param tag Use this to find audiobooks based on a certain tag.
     * @param title Use this to search audiobook titles with given words
     * @returns BaseAudioBookReturn list of books
     * @throws ApiError
     */
    public listAudioBooks(
        person?: string,
        term?: string,
        tag?: string,
        title?: string,
    ): CancelablePromise<Array<BaseAudioBookReturn>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/audiobooks',
            query: {
                'person': person,
                'term': term,
                'tag': tag,
                'title': title,
            },
        });
    }

    /**
     * Get a book by id.
     * If the book is in the db, return it.
     * If the book is not in the db, retrieve it from podcastindex, and add it to the db.
     * @param bookId the id of the given book to be returned
     * @returns CompleteAudioBookReturn Ok
     * @throws ApiError
     */
    public getAudioBook(
        bookId: number,
    ): CancelablePromise<CompleteAudioBookReturn> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/audiobooks/{bookId}',
            path: {
                'bookId': bookId,
            },
        });
    }

    /**
     * Add a rating or a comment to the book with the given id.
     * If the book is in the db, throw an error.
     * Otherwise, add the provided rating or comment to the list of ratings or comments
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateAudioBook(
        requestBody: CompleteAudioBookReturn,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/audiobooks/{bookId}',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Returns a list of the top 1000 trending audibooks
     * According to podcastindex
     * @returns BaseAudioBookReturn Ok
     * @throws ApiError
     */
    public getAllTrendingAudioBooks(): CancelablePromise<Array<BaseAudioBookReturn>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/audiobooks/allBooks',
        });
    }

}
